var u = (s, t, a) => new Promise((r, c) => {
  var v = (n) => {
    try {
      l(a.next(n));
    } catch (i) {
      c(i);
    }
  }, o = (n) => {
    try {
      l(a.throw(n));
    } catch (i) {
      c(i);
    }
  }, l = (n) => n.done ? r(n.value) : Promise.resolve(n.value).then(v, o);
  l((a = a.apply(s, t)).next());
});
import { ref as g, computed as y, watch as h } from "vue";
import { L as P, a as I, P as S, A as m, b as E } from "./index-BKMcmhwk.js";
const T = (s) => {
  var t, a, r;
  return !!(s.licenseId || (t = s.sourceInfo) != null && t.appSource && ((a = s.sourceInfo) != null && a.bucket) && ((r = s.sourceInfo) != null && r.filePath));
};
function p(s) {
  const t = g({}), a = g(!0), r = g({}), c = g(!0), v = y(() => ({
    "--border-radius": s.borderRadius
  })), o = y(() => {
    var e;
    return s.licenseId || ((e = t == null ? void 0 : t.value) == null ? void 0 : e.licenseId);
  }), l = y(() => {
    var d, f;
    const e = (f = (d = t.value) == null ? void 0 : d.meta) == null ? void 0 : f.live;
    if (!e) return null;
    if (e.recordingEnabled === !1)
      return {
        type: "no-recording",
        message: "Recording was not enabled for this live session."
      };
    if (e.recordingEnabled === !0) {
      if (e.state !== P.COMPLETED || !e.recordingAvailable)
        return {
          type: "recording-processing",
          message: "The live session recording is being processed and will be available shortly."
        };
      if (e.state === P.COMPLETED && e.recordingAvailable === !0)
        return {
          type: "recording-ready",
          message: null
        };
    }
    return null;
  }), n = () => u(this, null, function* () {
    try {
      if (s.licenseId) {
        const e = yield m.getAsset(s.licenseId);
        return t.value = e, e;
      } else if (s.sourceInfo) {
        const { appSource: e, bucket: d, filePath: f } = s.sourceInfo, A = yield E.getProxyAsset(
          e,
          d,
          f
        );
        return t.value = A, A;
      }
      return null;
    } catch (e) {
      (e == null ? void 0 : e.status) === 404 && (c.value = !1);
    }
  }), i = () => u(this, null, function* () {
    try {
      const e = yield m.getProcessingStatus(
        o.value
      );
      r.value = e;
    } catch (e) {
    }
  }), b = () => u(this, null, function* () {
    try {
      const e = yield n();
      if (!e)
        return;
      e.processedUrl ? r.value = {
        assetType: e.assetType,
        status: S.COMPLETED,
        createdAt: /* @__PURE__ */ new Date(),
        updatedAt: /* @__PURE__ */ new Date(),
        url: e.url,
        processedUrl: e.processedUrl,
        licenseId: o.value
      } : yield i();
    } finally {
      a.value = !1;
    }
  }), w = () => u(this, null, function* () {
    a.value = !0, s.token && I(s.token), yield b();
  });
  return h(
    () => s.token,
    (e) => {
      e && I(e);
    }
  ), {
    assetUrls: t,
    loading: a,
    processingStatus: r,
    isAssetLicenseDeleted: c,
    cssVariables: v,
    computedLicenseId: o,
    liveSessionStatus: l,
    getAsset: n,
    getProcessingStatus: i,
    getPlaybackData: b,
    initializePlayer: w
  };
}
export {
  p as u,
  T as v
};
